module.exports = __webpack_public_path__ + "static/media/provider-bpoker.a47d8bef.png";